/** Typed access to Vite env (VITE_* from the repo-root .env). Every value has a local-dev default. */
const e = import.meta.env;

export const env = {
  dev: e.DEV,
  apiBaseUrl: (e.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, '') || '/api/v1',
  firebase: {
    apiKey: (e.VITE_FIREBASE_API_KEY as string | undefined) || 'demo-api-key',
    projectId: (e.VITE_FIREBASE_PROJECT_ID as string | undefined) || 'demo-growhero',
    authDomain:
      (e.VITE_FIREBASE_AUTH_DOMAIN as string | undefined) || 'demo-growhero.firebaseapp.com',
    /** host:port of the Auth emulator; defaults to 127.0.0.1:9399 in dev, unset in prod builds. */
    authEmulatorHost:
      (e.VITE_FIREBASE_AUTH_EMULATOR_HOST as string | undefined) || (e.DEV ? '127.0.0.1:9399' : ''),
  },
  widgetRuntimeOrigin:
    (e.VITE_WIDGET_RUNTIME_ORIGIN as string | undefined) || 'http://localhost:5180',
  /** Marketing site origin (legal pages). VITE_LANDING_URL, else LANDING_URL via vite.config. */
  landingUrl: ((e.VITE_LANDING_URL as string | undefined) || 'http://localhost:4321').replace(
    /\/+$/,
    '',
  ),
} as const;
